import { render } from "./card-num.vue?vue&type=template&id=3d6b1000&scoped=true"
import script from "./card-num.vue?vue&type=script&lang=js"
export * from "./card-num.vue?vue&type=script&lang=js"

import "./card-num.vue?vue&type=style&index=0&id=3d6b1000&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6b1000"]])

export default __exports__